<template>
    <div name="reason" class="reason">
        <div class="container">
            <div class="section-header">
                <strong class="title">왜 바로돌봄일까요?</strong>
                <p class="sub-text">바로돌봄은 정신 질환자, 어르신 등의<br>
                    의료 취약계층 환자와 보호자, 센터 등<br>
                    모두가 만족할 수 있는 비대면 진료 서비스입니다.</p>
            </div>
            <div class="card-area">
                <ul class="card-list">
                    <li>
                        <img class="img-card" src="../../assets/mobile_barocare/img_reason3.png" alt="센터">
                        <strong class="card-title">센터</strong>
                        <div class="text-cont">
                            <strong>어르신 건강관리 최적화 서비스</strong>
                            <p>만성질환부터 급성 변비, 설사, 감기까지도<br>빠르게 전문 의사와 상담이 가능합니다</p>
                        </div>
                        <div class="text-cont">
                            <strong>센터별 최적화 서비스</strong>
                            <p>기관 별 관리자 페이지와 실시간 CS,<br>진료 일자를 조율하실 수 있습니다</p>
                        </div>
                    </li>
                    <li>
                        <img class="img-card" src="../../assets/mobile_barocare/img_reason2.png" alt="의료 취약 계층">
                        <strong class="card-title">의료 취약 계층</strong>
                        <div class="text-cont">
                            <strong>2시간 대기 후 1분 처방?</strong>
                            <p>편한 장소, 편한 시간에 대기 없이<br>언제든지 의사 선생님을 만나볼 수 있습니다</p>
                        </div>
                        <div class="text-cont">
                            <strong>빠르고 안전한 조제약 수령</strong>
                            <p>상주하시는 기관 인근 약국에서 빠르고 안전하게<br>조제약을 수령하실 수 있습니다</p>
                        </div>
                    </li>
                    <li>
                        <img class="img-card" src="../../assets/mobile_barocare/img_reason1.png" alt="보호자">
                        <strong class="card-title">보호자</strong>
                        <div class="text-cont">
                            <strong>반복적인 연차 사용, 이제 그만</strong>
                            <p>간단한 동의 절차만으로도 우리 부모님의 최첨단<br>건강 관리가 가능합니다</p>
                        </div>
                        <div class="text-cont">
                            <strong>원클릭 건강 데이터 확인</strong>
                            <p>진료 내용, 처방 문서, 약 보관/복약 안내와<br>원스톱 결제 내역까지 실시간 확인이 가능합니다</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'reason',
    mounted: function()
    {

    }
}
</script>

<style scoped>
    .reason {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #fff;
    }
    .reason .container{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin: 0 auto;
        padding: 146px 20px 120px;
        z-index: 1;
    }
    .section-header{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 32px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }
    .section-header .sub-text{
        margin-top: 14px;
        margin-bottom: 0;
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.6;
        color: #1A1A1A;
        text-align: center;
    }
    .card-area{
        width: 100%;
        margin-top: 70px;
    }
    .card-list{
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        gap: 50px;
        padding: 0;
        list-style-type: none;
        animation: fadeInUp1 2s;
    }
    .card-list li{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 503px;
        font-family: 'Pretendard';
        font-style: normal;
        text-align: center;
        color: #1A1A1A;
    }
    .card-title{
        margin-bottom: 13px;
        font-size: 26px;
        font-weight: 600;
        color: #0082EC;
        text-align: center;
    }
    .text-cont + .text-cont{
        margin-top: 19px;
    }
    .text-cont strong{
        display: inline-block;
        margin-bottom: 6px;
        font-size: 22px;
        font-weight: 600;
    }
    .text-cont p{
        margin: 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.6;
    }
    .card-list .img-card{
        width: 100%;
        height: 200px;
        margin-bottom: 27px;
        border-radius: 10px;
        object-fit: cover;
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Reason.vue